import {authServerInstance} from "../axiosInstance";

export const addUserCustomer = async (data) => {
  const response = await authServerInstance.post(`/user-customer`, data);
  return response;
};

export const updateUserCustomer = async (data) => {
  const response = await authServerInstance.put(`/user-customer`, data);
  return response;
};

export const searchUserCustomer = async (data) => {
  try {
    const response = await authServerInstance.post(
      `/user-customer/search`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getUserCustomerByUserId = async (userId, shId) => {
  try {
    const response = await authServerInstance.get(`user-customer/${userId}`);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getUserCustomerByUscId = async (uscId) => {
  try {
    const response = await authServerInstance.get(`user-customer/by-uscId/${uscId}`);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getUserDetail = async (data) => {
  try {
    const response = await authServerInstance.post(
      `console/user/user-detail`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const findUserCustomerByUserAndStakeholderAndActive = async (data) => {
  try {
    const response = await authServerInstance.post(
        `user-customer/active-stakeholders`,
        data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};



// The User Customer Group APIs
export const userCustomerGroupDropdown = async(opt = []) => {
  try{
    const response = await authServerInstance.get(`user-customer/group/dropdown`);
    console.log('the data of dropdown: ', response.data);
    return response.data.map((item) => {
      let data = {
        key: item.ucgId,
        text: item.ucgName,
        value: item.ucgId,
      };

      opt.forEach((option) => {
        data = {
          ...data,
          [option]: item[option],
        };
      });

      return data;
    });
  }catch (e) {
    console.error(e);
  }
}

export const createUserCustomerGroup = async(data) => {
  try{
    return await authServerInstance.post(
        `user-customer/group`,
        data
    );
  }catch (error) {
    console.error(error);
  }
}

export const updateUserCustomerGroup = async (id, data) => {
  try{
    return await authServerInstance.put(`user-customer/group/${id}`, data);
  }catch (e) {
    console.error(e)
  }
}

export const searchUserCustomerGroup = async (data) => {
  try{
    return await authServerInstance.post(`user-customer/group/search`, data);
  }catch(e) {
    console.error(e);
  }
}

export const getUserCustomerGroupById = async (id) => {
  try{
    const response = await authServerInstance.get(`user-customer/group/get-by-id/${id}`);
    return response.data;
  }catch(e){
    console.error(e);
  }
}

export const getShippersByCustomer = async (customerId) => {
  try {
    const response = await authServerInstance.get(`user-customer/shippers-by-customer/${customerId}`);
    return response.data;
  } catch (e) {
    console.error("Error fetching shippers by customer:", e);
    throw e;
  }
};
